export default __webpack_public_path__ + "static/media/defaultImageCompanyDetail.6236710a.svg";